// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4c25febe","825":"0f4c44df"}[chunkId] + ".chunk.js";
};